import React, { Fragment, useState } from "react";
import axios from "axios";
import swal from "sweetalert";

const Checkout = () => {
  const [amount, setAmount] = useState(20);
  const coin_wait = localStorage.getItem('coin_wait') || 0;

  const [depositInput, setDepositInput] = useState({
    accountType: 'BRISE',
    password: '',
    error_list: [],
  });

  const [loading, setLoading] = useState(false);

  const handleInput = (e) => {
    setDepositInput({ ...depositInput, [e.target.name]: e.target.value });
  };

  const handleIncrement = () => {
    setAmount(prev => prev + 20);
  };

  const handleDicrement = () => {
    setAmount(prev => Math.max(prev - 20, 20));
  };

  const depositSubmit = (e) => {
    e.preventDefault();
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      amount: amount,
      accountType: depositInput.accountType,
      password: depositInput.password,
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9'
    };

    if (auth_token && !loading) {
      setLoading(true);
      axios.post(`/sub-swap`, data).then(res => {
        if (res.data.status === 'success') {
          swal("Success", res.data.message, "success");
          setAmount(20);
          setDepositInput({ accountType: 'BRISE', password: '', error_list: [] });
        } else if (res.data.status === 'fail') {
          swal("Warning", res.data.message, "warning");
        } else {
          setDepositInput({ ...depositInput, error_list: res.data.validation_error });
        }
        setLoading(false);
      });
    }
  };

  return (
    <Fragment>
      <div className="container-fluid py-4">
        <div className="row">
          {/* Form Section */}
          <div className="col-md-7 mb-4">
            <div className="card shadow-sm p-4">
              <h3 className="mb-4 text-primary">Swap Your Tokens</h3>
              <form onSubmit={depositSubmit} noValidate>
                <div className="mb-3">
                  <label className="form-label">Amount</label>
                  <div className="d-flex">
                    <button type="button" className="btn btn-outline-secondary me-2" onClick={handleDicrement}>-</button>
                    <input
                      type="text"
                      className="form-control text-center"
                      name="amount"
                      value={amount}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!isNaN(value)) {
                          setAmount(Number(value));
                        }
                      }}
                    />
                    <button type="button" className="btn btn-outline-secondary ms-2" onClick={handleIncrement}>+</button>
                  </div>
                  <small className="text-danger">{depositInput.error_list.amount}</small>
                </div>

                <div className="mb-3">
                  <label className="form-label">Swap To</label>
                  <div className="d-flex flex-wrap gap-3">
                    {['BRISE', 'balance', 'd_balance'].map((type) => (
                      <div className="form-check" key={type}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="accountType"
                          id={type}
                          value={type}
                          onChange={handleInput}
                          checked={depositInput.accountType === type}
                        />
                        <label className="form-check-label" htmlFor={type}>
                          {type === 'BRISE' ? 'BRISE Reserve' : type === 'balance' ? 'Main Wallet' : 'Deposit Wallet'}
                        </label>
                      </div>
                    ))}
                  </div>
                  <small className="text-danger">{depositInput.error_list.accountType}</small>
                </div>

                <div className="mb-3">
                  <label className="form-label">Account Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    placeholder="Enter your password"
                    value={depositInput.password}
                    onChange={handleInput}
                    required
                  />
                  <small className="text-danger">{depositInput.error_list.password}</small>
                </div>

                <div className="form-check mb-3">
                  <input className="form-check-input" type="checkbox" id="terms" required />
                  <label className="form-check-label" htmlFor="terms">
                    I agree to the terms and conditions
                  </label>
                </div>

                <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                  {loading ? 'Processing...' : 'Confirm Swap'}
                </button>
              </form>
            </div>
          </div>

          {/* Summary Section */}
          <div className="col-md-5">
            <div className="card shadow-sm p-4 bg-light">
              <h5 className="mb-4">Swap Summary</h5>
              <ul className="list-group list-group-flush">
                <li className="list-group-item d-flex justify-content-between">
                  <span>Swap Type:</span> <strong>Token Swap</strong>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  <span>Token Amount:</span> <strong>{amount} BRISE</strong>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  <span>Asset Value:</span> <strong>${(amount * coin_wait).toFixed(2)}</strong>
                </li>
              </ul>
              <div className="mt-4 text-center">
                <span className="badge bg-primary p-2">Instant 100% Conversion</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Checkout;
